const BLOG_TAG_COLORS = [
  '#7a1f00',
  'var(--color-teal-900)',
  '#4e076f',
] as const;

export const getBlogTagColor = (tag: string) => {
  const firstLetter = tag.trim().charAt(0).toLowerCase();
  const alphabetIndex = firstLetter.charCodeAt(0) - 'a'.charCodeAt(0);

  if (alphabetIndex < 0 || alphabetIndex > 25) {
    return BLOG_TAG_COLORS[0];
  }

  return BLOG_TAG_COLORS[alphabetIndex % BLOG_TAG_COLORS.length];
};
